import React from "react"
import { Button } from "reactstrap"
import styles from "./WinnerChooser.module.scss"

function PlayerBox({ team, setWinner }) {
	return (
		<div className={`${styles.columnFlex} ${styles.teamSection}`}>
			<h3>{`${team.name} ${team.surname ?? ""}`}</h3>
			<Button.Ripple color="primary" outline onClick={() => setWinner(team)}>
				Proglasi pobjednikom
			</Button.Ripple>
		</div>
	)
}

export default PlayerBox
